export default __webpack_public_path__ + "static/media/XMR.7cf5a54a.svg";